import React from 'react';

import { SCROLL_LOCK_IGNORE_CLASS } from 'helpers/ScrollHelpers';

import { cx } from 'helpers/StylingHelpers';

import ModalActions from './ModalActions';
import ModalHeader from './ModalHeader';

import type { DataTestId } from 'types';

import styles from './ModalBody.module.scss';

export interface Props extends DataTestId {
  //
  className?: string,
  classNames?: {
    root?: string,
    children?: string
  },
  //
  headerProps?: React.ComponentProps<typeof ModalHeader>,
  actionsProps?: React.ComponentProps<typeof ModalActions>,
  //
  pre?: React.ReactNode,
  children?: React.ReactNode,
  post?: React.ReactNode
  //
}

const ModalBody = React.forwardRef<HTMLDivElement, Props>((
  props: Props,
  ref
) => {
  const {
    //
    className,
    classNames = {},
    //
    headerProps,
    actionsProps,
    //
    dataTestId,
    //
    pre,
    children,
    post
    //
  } = props;

  return (
    <div
      ref={ref}
      className={cx(
        styles.root,
        className,
        classNames?.root
      )}
      data-testid="modal.body"
    >

      {/* Pre */}
      {pre}

      {/* Header */}
      {headerProps && (
        <ModalHeader
          withCloseButton={false}
          {...headerProps}
        />
      )}

      {/* Children */}
      {children && (
        <div
          className={cx(
            styles.children,
            SCROLL_LOCK_IGNORE_CLASS,
            classNames?.children
          )}
          data-testid="modal.body-children"
        >
          {children}
        </div>
      )}

      {/* Actions */}
      {actionsProps && (
        <ModalActions {...actionsProps} />
      )}

      {/* Post */}
      {post}

    </div>
  );
});

export default ModalBody;
